import { render, staticRenderFns } from "./OrderDetailPanal.vue?vue&type=template&id=e12d7ba6&scoped=true&"
import script from "./OrderDetailPanal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPanal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPanal.vue?vue&type=style&index=0&id=e12d7ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d7ba6",
  null
  
)

export default component.exports